<template>
  <BuscadorGruposDesktopHome
    :informacion-busqueda-grupos="filterInformationStore"
    :filtro-viajes="filtroViajes"
    @setear-destino-buscador="setDestiny"
    @setear-fecha-buscador="setFechasViajes"
    @limpiar-destino-buscador="clearDestinos"
    @limpiar-fecha-buscador="clearFechas"
    @do-busqueda-viajes-grupos="goToCatalogoViajesGrupos" />

  <BuscadorGruposMobileHome
    :informacion-busqueda-grupos="filterInformationStore"
    :filtro-viajes="filtroViajes"
    @setear-destino-buscador="setDestiny"
    @setear-fecha-buscador="setFechasViajes"
    @limpiar-destino-buscador="clearDestinos"
    @limpiar-fecha-buscador="clearFechas"
    @do-busqueda-viajes-grupos="goToCatalogoViajesGrupos" />
</template>

<script setup>
  import BuscadorGruposDesktopHome from './buscadorGrupos/BuscadorGruposDesktopHome.vue';
  import BuscadorGruposMobileHome from './buscadorGrupos/BuscadorGruposMobileHome.vue';
  import { ViajesGrupoCatalogo } from '@/router/RouterNames';
  import { computed, onBeforeMount } from 'vue';
  import { ref } from 'vue';
  import { buscadorGrupos } from '@/store_pinia/buscadorGrupos';
  import router from '@/router';
  import { useFiltroGruposStore } from '@/store_pinia/filtros/filtroGrupos';
  import moment from 'moment-timezone';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { viajesGrupos } from '@/store_pinia/viajesGrupo';

  const filterInformationStore = buscadorGrupos();
  const route = ref(router.currentRoute);
  const filtroGruposStore = useFiltroGruposStore();
  const loadingStore = useLoadingStore();
  const viajesGruposStore = viajesGrupos();

  const filtroViajes = computed(() => filterInformationStore.filtrosViajes);

  function setDestiny(lugarExperiencia) {
    filterInformationStore.setLugarExperiencia(lugarExperiencia);
  }

  function setFechasViajes(date) {
    filterInformationStore.setDateBuscadorGrupos(date);
  }

  function clearDestinos() {
    filterInformationStore.clearDestinyBuscadorGrupos();
    filtroGruposStore.setFiltroLugaresExperiencia([]);
  }

  function clearFechas() {
    filterInformationStore.clearDateBuscadorGrupos();
    filtroGruposStore.setFiltroMonth(null);
  }

  async function applyFiltrosViajesGrupos() {
    try {
      loadingStore.show();
      filtroGruposStore.aplicarFiltros(await viajesGruposStore.fetchResumenViajes());
    } catch (error) {
      console.error('Error refreshing viajes:', error);
    } finally {
      loadingStore.hide();
    }
  }

  async function goToCatalogoViajesGrupos() {
    const lugares = filterInformationStore.lugarExperiencia
      ? [{ ...filterInformationStore.lugarExperiencia, selected: true }]
      : [];

    if (lugares.length || filtroGruposStore.getLugaresExperiencia.length) {
      filtroGruposStore.setFiltroLugaresExperiencia(lugares);
    }
    if (filterInformationStore.date) {
      filtroGruposStore.setFiltroMonth(moment(filterInformationStore.date));
    }

    if (route.value.name === ViajesGrupoCatalogo) {
      await applyFiltrosViajesGrupos();
    } else {
      router.push({
        name: ViajesGrupoCatalogo,
      });
    }
  }

  onBeforeMount(() => {
    filterInformationStore.setFilterInformation();
  });
</script>
